<template>
  <div class="blog-container">
    <iframe
      src="https://fantasylineups.com/blog/"
      class="blog-iframe"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "NhlBlog",
};
</script>

<style scoped>
.blog-container {
  width: 100%;
  height: calc(100vh - 120px);
}

.blog-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
